import { FC } from 'react'
import cn from 'clsx'
import Nav from '@components/common/Nav'
import PreHeader from '@components/common/PreHeader'
import { Sidebar, useUI } from '@components/ui'
import CartSidebarView from '@components/cart/CartSidebarView'

interface Props {
  navigation?: any
  globalSettings?: any
}

const ns = `site-header`

const SidebarUI: FC<{
  customersAlsoBoughtData: any[]
  cartPromo: string
}> = ({ customersAlsoBoughtData, cartPromo }) => {
  const { displaySidebar = false, closeSidebar, sidebarView } = useUI()

  return (
    <Sidebar onClose={closeSidebar} isActive={displaySidebar}>
      {sidebarView === 'CART_VIEW' && (
        <CartSidebarView
          customersAlsoBoughtData={customersAlsoBoughtData}
          cartPromo={cartPromo}
        />
      )}
    </Sidebar>
  )
}

const Header: FC<Props> = ({ navigation, globalSettings }) => {
  const rootClassnames = cn({
    [`${ns}`]: true,
  })

  return (
    <>
      <header className={rootClassnames}>
        <PreHeader navigation={navigation} />
        <Nav navigation={navigation} />
      </header>
      <SidebarUI {...globalSettings} />
    </>
  )
}

export default Header
